export default {"src":"/_next/static/media/Grace.8b1e78cc.svg","height":350,"width":350,"blurWidth":0,"blurHeight":0};